
import { defineComponent } from 'vue';
import { InputElementTypes } from '@/enums';
import TextInputStyleProvider from '@/components/style-providers/TextInputStyleProvider.vue';
import BaseInput from '@/components/form-controls/base/BaseInput.vue';

export default defineComponent({
  name: 'TextInput',
  components: {
    TextInputStyleProvider,
    BaseInput
  },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      InputElementTypes
    };
  }
});
